import { Layout, Tag, TagGroup, Text } from '@oneaudi/unified-web-alpha-components';
import { AccessoriesItem } from '~/graphql/mapper';

export type SelectionOption = {
	id: string;
	label: string;
	active: boolean;
	items: AccessoriesItem[];
};

type SelectFieldProps = {
	selectionOptions: SelectionOption[];
	label: string;
	onChange: (selectedOption: SelectionOption) => void;
};

export const Categories = ({ selectionOptions, label, onChange }: SelectFieldProps) => {
	return (
		<Layout direction={'column'} rowGap="16px">
			<Text variant={{ order: '2', type: 'copy', style: 'normal' }} tag="p">
				{label}
			</Text>
			<TagGroup size="md">
				{selectionOptions.map((option) => {
					return (
						<Tag
							key={option.id}
							label={`${option.label} (${option.items.length})`}
							variant="selectable"
							checked={option.active}
							value={option.id}
							onChange={() => onChange(option)}
							size="sm"
						/>
					);
				})}
			</TagGroup>
		</Layout>
	);
};
